module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/play-background-66ede53fb7ddd40f3282e80c2e5653d8.png";